// The basics
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';

// Action creators and helpers
import { establishCurrentUser } from '../modules/auth';
import { isServer } from '../store';

import Header from './header';
import Footer from './footer';
import Routes from './routes';

import 'bulma-carousel/dist/css/bulma-carousel.min.css';
import './app.css';
import './styles/homepage.css';
import './styles/viewpropertyrent.css';
import './styles/searchresult.css';
import './styles/searchcard.css';
import './styles/imagemodal.css';


class App extends Component {
  componentWillMount() {
    if (!isServer) {
      this.props.establishCurrentUser();
    }
  }

  render() {
    return (
      <div id="app">
        <Header
          isAuthenticated={this.props.isAuthenticated}
          current={this.props.location.pathname}
        />
        <div id="content" style={{ minHeight: "calc(100vh - 14.75rem)" }}>
          <Routes />
        </div>
        <Footer
          isAuthenticated={this.props.isAuthenticated}
          current={this.props.location.pathname}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ establishCurrentUser }, dispatch);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(App)
);



// WEBPACK FOOTER //
// ./src/app/app.js